import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/tooltip';
import { PublicService } from 'src/app/core/services/public.service';
import Swal from 'sweetalert2';
import { AddQueryDialogComponent } from './add-query-dialog/add-query-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { EncryptService } from 'src/app/core/services/encrypt.service';

@Component({
  selector: 'app-provider-registration-queries',
  templateUrl: './provider-registration-queries.component.html',
  styleUrls: ['./provider-registration-queries.component.scss'],
  viewProviders: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class ProviderRegistrationQueriesComponent implements OnInit {

  constructor(
    private publicService: PublicService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
  ) { }

  token : any;
  quariesList : any[] = [];
  dataSource = new MatTableDataSource<any>();
  resultsLength : any = 0
  displayedColumns: string[] = [ 'queryRaised','queryResponse','createdBy', 'updatedBy','createdDate','updatedDate', 'action'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit(): void {
    this.token;
    this.token = this.route.snapshot.queryParams.token;
    
    if(this.token){
      this.getProviderQueries(this.token)
    }
  }

  getProviderQueries(token : any){
    Swal.showLoading()
    this.publicService
      .getAllProviderQueries(token)
      .subscribe(
        (res: any) => {
          Swal.close();
          this.quariesList = res.body
          this.dataSource = new MatTableDataSource<any>(res.body);
          this.resultsLength = res.body.length;
          this.dataSource.paginator = this.paginator!;
        },
        (err: any) => {
          Swal.close()
          if (err && err.error && err.error.message) {
            Swal.fire('', err.error.message, 'error');
          } else if (err && err.message) {
            Swal.fire('', err.message, 'error');
          } else {
            Swal.fire('', 'Something went wrong', 'error');
          }
        }
      )
  }

  openAddQuery(id:any){

    let query = this.quariesList.find((item:any)=> item.id === id)
   const dialogRef = this.dialog.open(AddQueryDialogComponent, {
      data: {
        query
      },
      height: "450px",
      width: "700px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.getProviderQueries(this.token)
      }
    });
  }

}
